import { useMemo } from 'react';
import { ossPrefix } from '@/constant';
import cx from './index.module.scss';

// 0-100次
const SERVICE_RECORD_TIMES_LOW_IMG = ossPrefix + '/index_module/index/lwys5rap_628656.png';
// 100-300次
const SERVICE_RECORD_TIMES_LOW_MEDIUM = ossPrefix + '/index_module/index/lwys5raq_628656.png';
// 300次+
const SERVICE_RECORD_TIMES_LOW_HIGHT = ossPrefix + '/index_module/index/lwys5rar_628656.png';

interface Props {
  storeOrderInfo: StoreOrderInfo;
}

const ServiceTimesCard: React.FC<Props> = props => {
  const { storeOrderInfo } = props;
  const imgSrc = useMemo(() => {
    const isShowLowImg = storeOrderInfo?.totalOrders <= 100;
    const isShowMediumImg = storeOrderInfo?.totalOrders > 100 && storeOrderInfo?.totalOrders <= 300;

    if (isShowLowImg) {
      return SERVICE_RECORD_TIMES_LOW_IMG;
    } else if (isShowMediumImg) {
      return SERVICE_RECORD_TIMES_LOW_MEDIUM;
    } else {
      return SERVICE_RECORD_TIMES_LOW_HIGHT;
    }
  }, [storeOrderInfo?.totalOrders]);

  return (
    <div className={cx('container')}>
      <img className={cx('picture')} src={imgSrc} />
      <div className={cx('text')}>
        累计订单量 <span className={cx('numbers')}>{storeOrderInfo?.totalOrders || 0}</span> 单，累计服务人数
        <span className={cx('numbers')}> {storeOrderInfo?.totalCustomers || 0}</span> 人
      </div>
    </div>
  );
};

export default ServiceTimesCard;
